import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import { Container, Col } from '../../../../base/Grid';
import Button from '../../../../base/Button';

export const DivModalContainerStyled = styled.div`
  position: absolute;

  &.is-active {
    position: absolute;
    top: 0;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    .nmx-modal {
      display: block;
      @media all and (-ms-high-contrast: none) {
        top: ${rem(50)};
        left: 25%;
      }
    }

    .nmx-modal__overlay {
      display: flex;
      align-items: center;
      margin: auto;
    }
  }
`;

export const ContainerModalStyled = styled(Container)` 
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const largeUp = theme.useMediaQuery(theme.breakpoints.up('large'));
    const xlargeUp = theme.useMediaQuery(theme.breakpoints.up('xlarge'));
    let width = '100%';

    if (xlargeUp) {
      width = '60%';
    } else if (largeUp) {
      width = '75%';
    } else if (mediumUp) {
      width = '90%';
    }
    return css`
      .is-active {
        display: block;
      }
      padding: 0;
      position: absolute;
      z-index: ${theme.zIndex.modalMain};
      display: none;
      width: ${width};
      max-width: ${xlargeUp ? rem(900) : rem(800)};
      height: ${mediumUp ? 'auto' : '100%'};
      border: 0;
      margin: 0 auto;
      backface-visibility: hidden;
      background-color: ${theme.colors.neutral.white};
      box-shadow: none;
      overflow-y: ${mediumUp ? 'auto' : 'scroll'};
      border-radius: ${mediumUp ? rem(4) : 0};
      min-height: ${mediumUp ? rem(300) : 0};
    `;
  }
}
`;

export const DivModalOverlayStyled = styled.div`
  ${({ theme }) => css`
      position: fixed;
      z-index: ${theme.zIndex.modalOverlay};
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: none;
      background-color: rgba(0,0,0,.5); /** TODO: leverage shadow theme (once organized) */
      overflow-y: scroll;
      .is-active {
        display: flex;
        align-items: center;
        margin: auto;
      }
    `
}
`;

export const ColAnnouncementStyled = styled(Col)` 
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));

    return css` 
    padding: ${mediumUp ? rem(48) : rem(16)};
    background-color: ${theme.colors.neutral.gray95};
    text-align: center;
    .icon-login-got-easier {
      display: ${mediumUp ? 'inline-block' : 'none'};
    }
   `;
  }
}
`;

export const ColLoginContentStyled = styled(Col)` 
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));

    return css` 
      padding: ${mediumUp ? rem(48) : rem(16)};
   `;
  }
}
`;

export const UlAnnouncementStyled = styled.ul`
  text-align: left;
  li {
    padding-left: ${rem(16)};
    padding-bottom: ${rem(12)};
  }
`;

export const DivLoginErrorStyled = styled.div` 
${({ theme }) => css` 
    display: flex;
    align-items: center;
    padding: ${rem(16)};
    border-left: ${rem(5)} solid ${theme.colors.system.negativeError};
    margin-bottom: ${rem(16)};
    background-color: ${theme.colors.neutral.gray99};

    p {
      flex: 1 0 auto;
      text
    }

    .nmx-icon {
      .icon-fill {
        fill: ${theme.colors.system.negativeError};
      }
      .icon-color {
        fill: ${theme.colors.neutral.white};
      }
    }
   `
}
`;

export const ButtonCloseStyled = styled.button` 
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));

    return css`
    position: absolute;
    top: 0;
    right: 0;
    width: ${rem(42)};
    min-width: unset;
    padding: ${rem(12)};
    border: none;
    float: right;
    left: ${mediumUp ? '50%' : '90%'};
    background: transparent;
    svg { 
      height: ${rem(16)};
      width: ${rem(16)};
    }
    hover {
      cursor: pointer;
    }
   `;
  }
}
`;

export const DivOtherLoginStyled = styled.div` 
  border-Top: 1px solid #979797;
  padding-top: ${rem(24)};
  text-align: center;
`;

export const ColFormStyled = styled(Col)` 
  margin-bottom: ${rem(16)};
`;

export const UlLoginLinksStyled = styled.ul` 
  display: inline-block;
  li {
    display: inline-block;
    margin: ${rem(8)};
  }
`;

export const ButtonLoginStyled = styled(Button)` 
  display: block;
  margin: auto;
  margin-bottom: ${rem(16)};
`;
